import React from "react";
import { Image, Text, View } from "@react-pdf/renderer";
import { pdfStyles } from "@repo/print-pdf/shared";
import type { PrintDataFields } from "../../print/hooks/use-print-data";

export const CommentairesBlock: React.FC<{ data: PrintDataFields }> = ({
  data,
}) => (
  <View style={pdfStyles.commentSection}>
    <Text style={pdfStyles.label}>Commentaires :</Text>
    <Text style={{ fontSize: 9, color: "#4b5563", marginTop: 5 }}>
      {data.comments}
    </Text>
  </View>
);
